import styled from "styled-components";
import { Progress } from "antd";

const ProgressBar = styled(Progress)`
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    line-height: 0;
`;

export const S = {
  ProgressBar
}